import React, { useRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import { motion, useTransform, useScroll } from 'framer-motion';
import Placeholder from './Placeholder';

const VideoContainer = styled(motion.div)`
  width: 80%;
  max-width: 1200px;
  margin: 0 auto;
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);
  aspect-ratio: 16 / 9;
`;

const IframeContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

const StyledIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  position: absolute;
  top: 0;
  left: 0;
`;

const SectionContainer = styled.section`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 2rem;
`;

const VideoSection = () => {
  const containerRef = useRef(null);
  const [videoLoaded, setVideoLoaded] = useState(false);
  
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ['start end', 'end start'],
  });
  
  const opacity = useTransform(scrollYProgress, [0, 0.5, 1], [0, 1, 1]);
  const scale = useTransform(scrollYProgress, [0, 0.5, 1], [0.8, 1, 1]);

  useEffect(() => {
    // Simulate loading to ensure proper rendering
    const timer = setTimeout(() => {
      setVideoLoaded(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <SectionContainer ref={containerRef}>
      <VideoContainer
        style={{ opacity, scale }}
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8 }}
      >
        {videoLoaded ? (
          <IframeContainer>
            <StyledIframe
              src="https://player.vimeo.com/video/1074767025?h=2b43f45c66"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              title="INO STUDIO Demo Video"
            />
          </IframeContainer>
        ) : (
          <Placeholder text="Loading video..." />
        )}
      </VideoContainer>
    </SectionContainer>
  );
};

export default VideoSection;